//画面幅428以下かどうかチェック（スマホ）
export function isMobileWidth() {
  const ww = window.innerWidth;
  return ww <= 428;
}
